window.DesktopMenu ?= {}

DesktopMenu.removeMenuHtml = ->
  $('.menu-button').remove()
  $('#menu-modal').remove()

DesktopMenu.displayMenuHtml = (modalHtml) ->
  unless modalHtml?
    DesktopMenu.removeMenuHtml()

  $('.menu-button').css('display', 'inline-block')
  $('section.deal').after(modalHtml)
  GIG.Modal.reloadBindings($('#menu-modal'))

DesktopMenu.ajax_request = (menuData) ->
  $.ajax
    url      : menuData.formattedUrl
    dataType : 'html'
    success  : DesktopMenu.displayMenuHtml
    error    : DesktopMenu.removeMenuHtml

DesktopMenu.init = ({menuData}, done) ->
  unless menuData?
    DesktopMenu.removeMenuHtml()
    return done()

  DesktopMenu.ajax_request menuData
  done()

module.exports = DesktopMenu



// WEBPACK FOOTER //
// ./modules/menu/frontend/desktop_menu.coffee